import { motion, AnimatePresence } from "framer-motion";
import { X, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MultipleWalletsModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const MultipleWalletsModal: React.FC<MultipleWalletsModalProps> = ({ isOpen, onClose }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="fixed inset-0 modal-overlay-blur z-50 transition-opacity"
                    />
                    <div className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95, y: 20 }}
                            animate={{ opacity: 1, scale: 1, y: 0 }}
                            exit={{ opacity: 0, scale: 0.95, y: 20 }}
                            className="w-full max-w-[510px] rounded-[24px] glass-panel p-6 md:p-12 overflow-hidden shadow-2xl pointer-events-auto relative flex flex-col items-center text-center"
                        >
                            <button
                                onClick={onClose}
                                className="absolute top-5 right-5 p-2 text-muted-foreground hover:text-foreground hover:bg-muted/50 rounded-full transition-all z-20"
                            >
                                <X size={18} />
                            </button>

                            <div className="relative z-10 flex flex-col items-center w-full">
                                <div className="mb-8 relative">
                                    <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center border border-primary/20 relative z-10">
                                        <AlertTriangle className="w-10 h-10 text-yellow-500" />
                                    </div>
                                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-primary/20 rounded-full blur-2xl -z-10" />
                                </div>

                                <h2 className="text-[28px] font-bold leading-tight mb-4 text-foreground font-display tracking-tight">
                                    Multiple Wallet Extensions Detected
                                </h2>

                                <p className="text-muted-foreground text-[15px] leading-relaxed mb-8 max-w-[90%]">
                                    Multiple browser wallet extensions are causing a conflict.
                                    Please disable all wallet extensions except MetaMask, then
                                    reload the page and try again.
                                </p>

                                <Button
                                    onClick={onClose}
                                    className="font-medium bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-200 h-12 text-lg rounded-xl px-8"
                                >
                                    Got it
                                </Button>
                            </div>

                            <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/5 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2 pointer-events-none" />
                            <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-500/5 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/2 pointer-events-none" />
                        </motion.div>
                    </div>
                </>
            )}
        </AnimatePresence>
    );
};

export default MultipleWalletsModal;
